import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import tagsView from './modules/tagsView'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { user, tagsView },
  getters: {
    token: state => state.user.token,
    name: state => state.user.name,
    menus: state => state.user.menus,
    visitedViews: state => state.tagsView.visitedViews
  }
})
